export default "__VITE_ASSET__Bd$Yt_tp__"